import React from "react";
import { gql, useMutation } from "@apollo/client";
import { FETCH_TRANSACTIONS_QUERY } from "../graphql";
import leon from "../icons/leon.png";
import tram from "../icons/tram.png";

export const Transaction = ({ transaction }) => {
  const DELETE_TRANSACTION = gql`
    mutation deleteItem($transactionId: ID!) {
      deleteItem(transactionId: $transactionId)
    }
  `;

  const [deleteFunction] = useMutation(DELETE_TRANSACTION, {
    refetchQueries: [{ query: FETCH_TRANSACTIONS_QUERY }],
  });

  const sign = transaction.value < 0 ? "-" : "+";

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <li className={transaction.value < 0 ? "minus" : "plus"}>
      {transaction.user === "Leon" ? (
        <img
          src={leon}
          alt="leonIcon"
          className="photo"
          width="50"
          height="50"
        />
      ) : (
        <img
          src={tram}
          alt="tramIcon"
          className="photo"
          width="50"
          height="50"
        />
      )}
      <div>
        <b>{transaction.category}</b>
      <br></br>
      <div className='desc'>
        {transaction.desc}
      </div>
      
      {"  "}
      </div>
      
      <span>
        {sign}${numberWithCommas(Math.abs(transaction.value))}
      </span>

      <button
        className="delete-btn"
        onClick={() => {
          deleteFunction({ variables: { transactionId: transaction.id } });
        }}
      >
        x
      </button>
    </li>
  );
};
